import readingTime from 'reading-time/lib/reading-time';

export function init() {
  console.log('[loaded] stage-m');
  const stageMs = document.querySelectorAll('.stage-m');

  stageMs.forEach((stageM) => {
    const readingInfo = stageM?.querySelector('.stage-m__reading-info');
    const readingTimeElement = readingInfo?.querySelector(
      '.reading-time',
    ) as HTMLElement;
    const article = document?.querySelector('.with-reading-time');
    
    if (readingTimeElement && !article) {
      readingTimeElement.style.display = 'none';
      return;
    }

    if (!readingTimeElement || !article) return;

    const readingTimeAmount = stageM?.querySelector('.reading-time__amount');

    if (!readingTimeAmount) {
      readingTimeElement.style.display = 'none';
      return;
    }

    const time = readingTime(article.innerHTML);
    if (time?.minutes) {
      const mins = typeof time.minutes === 'number' ? Math.ceil(time.minutes).toString() : time.minutes;
      readingTimeAmount.textContent = mins;
    } else {
      readingTimeElement.style.display = 'none';
    }
  });
}
